import { IconNames } from "../../../../../../components/Icons/styles/iconNames";
import {
  DocumentStages,
  DocumentStatus,
  TransactionalEmailEvents,
} from "../../../../../../graphql/__GENERATED__/types";
import useDocumentDetails from "../../../../../../hooks/useDocumentDetails";
import { SectionFooterButton } from "../../../components/SectionFooter";
import { useMemo } from "react";

const useFooterButtons = () => {
  const {
    documentData: { proposalResult, status, stage },
    copyQuotationFormUrl,
    handleSendEmail,
    handleArchiveProposal,
    handleSetDocumentsAsSent,
  } = useDocumentDetails();

  const proposalForm = [
    {
      text: "Formulário Completo",
      iconName: IconNames.Share,
      onClick: copyQuotationFormUrl,
    },
  ];

  const proposalActions = [
    {
      text: "Enviar",
      onClick: async () =>
        handleSendEmail(TransactionalEmailEvents.UploadedProposal),
      iconName: IconNames.Send,
    },
    status !== DocumentStatus.Sent && {
      text: "Marcar como enviada",
      onClick: handleSetDocumentsAsSent,
      iconName: IconNames.Sent,
    },
    {
      text: "Arquivar",
      onClick: handleArchiveProposal,
      iconName: IconNames.Archive,
    },
  ];

  const footerButtons = useMemo(() => {
    if (stage !== DocumentStages.Proposal) return [];
    return proposalResult ? proposalActions : proposalForm;
  }, [proposalResult, stage]);

  return footerButtons.filter(Boolean) as unknown as SectionFooterButton[];
};

export default useFooterButtons;
